import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import viralFoxLogo from "@/assets/viral-fox-logo.png";

const Navbar = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 bg-background/80 backdrop-blur-lg border-b border-border/20">
      <div className="max-w-7xl mx-auto px-6 h-16 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <img src={viralFoxLogo} alt="Viral Fox" className="h-8 w-8 object-contain" />
          <span className="text-sm font-semibold tracking-wide text-foreground">VIRAL FOX</span>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={toggleTheme}
            className="animate-shake-entrance px-3 py-2 rounded-full bg-secondary border border-border/30 flex items-center gap-2 text-muted-foreground hover:text-foreground hover:bg-accent transition-all text-xs font-medium"
            aria-label={mounted && theme === "dark" ? "Dark Mode - Switch to light mode" : "Light Mode - Switch to dark mode"}
          >
            {mounted && theme === "dark" ? (
              <>
                <Moon className="w-4 h-4" />
                Dark Mode
              </>
            ) : (
              <>
                <Sun className="w-4 h-4" />
                Light Mode
              </>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;